import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        clientId: "3fef599d-baef-4fa8-9968-79d0d1ab3e80",
        authority: "https://login.microsoftonline.com/871b752d-d883-419b-960f-bab9f11572ee/",
        redirectUri: process.env.REACT_APP_AUTH_URL,
        navigateToLoginRequestUrl: true
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            }
        }
    }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
    scopes: ["User.Read"]
};

// For logout
export const logoutRequest = {
    postLogoutRedirectUri: process.env.REACT_APP_LOGOUT_REDIRECT_URL
};

// Add the endpoints here for Microsoft Graph api services you'd like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};